import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Button, Dimmer, Loader, Input, Message } from 'semantic-ui-react';

export function MembershipBillingDayModal({ accountId, onUpdate }) {
  const [open, setOpen] = React.useState();
  const [loading, setLoading] = React.useState();
  const [day, setDay] = React.useState();
  const [error, setError] = React.useState();

  const save = React.useCallback(async () => {
    await Promise.all([setLoading(true), setError(false)]);
    const { status, body } = await fetchApi({
      url: `/payments/programs/${accountId}/membership/set-bill-day`,
      body: { day },
    }).catch(e => ({ body: e }));
    await setLoading(false);
    if (status === 200) {
      onUpdate();
      setOpen(false);
    } else {
      setError(body);
    }
  }, [day]);

  return (
    <Modal
      open={open}
      trigger={<Button floated="left" onClick={() => setOpen(true)}>Change Bill Day</Button>}
    >
      <Modal.Header>Change Billing Day</Modal.Header>
      <Modal.Content>
        <Dimmer.Dimmable dimmed={loading}>
          {error && (
            <Message negative>
              <Message.Header>Oops - Changes Failed</Message.Header>
              <pre>{`${JSON.stringify(error)}`}</pre>
            </Message>
          )}
          <Dimmer active={loading}>
            <Loader />
          </Dimmer>
          <div>
            This change will have no effect on the &quot;refresh day&quot; (when the quantity limit resets),
            but only on the day we attempt to bill for the next period of service. In most cases, it will
            result in their next bill coming SOONER than expected because we need to bill in advance for
            the additional discounts rather than giving discounts without being paid.

            <div style={{ margin: '20px 0', textAlign: 'center' }}>
              <Input
                label="Day of the Month On Which To Bill the User:"
                placeholder="1"
                type="number"
                onChange={(e, { value }) => setDay(value)}
              />
            </div>
          </div>
        </Dimmer.Dimmable>
      </Modal.Content>
      <Modal.Actions>
        {!loading && <Button basic onClick={() => setOpen(false)}>Cancel</Button>}
        <Button primary loading={loading} disabled={Number.isNaN(Number(day)) || day < 1 || day > 28} onClick={save}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

MembershipBillingDayModal.propTypes = {
  accountId: PT.number,
  onUpdate: PT.func.isRequired,
};

MembershipBillingDayModal.defaultProps = {
  accountId: 0,
};
